import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import CampaignReport from '@/components/campaign-report'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/campaign/$campaignId/report')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: () => <CampaignReportWrapper />,
})

function CampaignReportWrapper() {
  const { campaignId } = Route.useParams()
  return (
    <Layout.Body>
      <CampaignReport campaignId={campaignId} />
    </Layout.Body>
  )
}
